import React, { useEffect, useState } from 'react';

import { useLocation, useHistory } from 'react-router-dom';

// locales
import { useTranslation } from 'react-i18next';
import { translations } from 'locales/i18n';

// calculators data
import { calculators } from '../data';

// components & atoms
import CalcListItem from '../ListItem';

// styles
import { Wrapper } from './styles';

interface IProps {
  type: string;
}

export const CalculatorsList = ({ type }: IProps) => {
  // locales hook
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (location.pathname.length > 42) history.push(location.pathname);
  }, []);

  const renderList = type === 'preview' ? calculators.slice(0, 3) : calculators;

  return (
    <Wrapper>
      {renderList &&
        renderList.map(item => (
          <CalcListItem
            key={item.name}
            type={type}
            name={item.name}
            icon={item.iconSrc}
            title={t(translations.calculatorsPage.calculators[item.name].title)}
            description={t(
              translations.calculatorsPage.calculators[item.name].description,
            )}
            url={item.url}
            buttonText={item.button}
          />
        ))}
    </Wrapper>
  );
};

export default CalculatorsList;
